// department_role_management_excel_controller.js
import React, { useState } from "react";
import axios from "axios";


const useDepartmentRoleManagementExcel = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getDepartmentRoleManagementExcelData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/organization_structure/api/department/role/management/excel', {
            responseType: 'blob',
            params: params,
        })
            .then((response) => {
                console.log('response', response);
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `角色身份管理.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
    }
    
    const getDepartmentRoleManagementExcelDataSample = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/organization_structure/api/department/role/management/sample_excel', {
            responseType: 'blob',
            params: params,
        })
            .then((response) => {
                console.log('response', response);
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `角色身份管理範例.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
    }

    const importDepartmentRoleManagementExcelData = (data) => {
        onBefore({
            axiosMode: "import"
        })
        const files = data?.file;
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('classify_structure_id', 8);
        form_data.append('default_column', JSON.stringify(data?.columns));
        axios
            .post('/organization_structure/api/department/role/management/excel', form_data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                // setResponseData(responseData.data)

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }

    // const [data, setData] = useState([])
    // const getTaskClassificationExcelData = (params) => {
    //     onBefore({
    //         axiosMode: "get"
    //     })
    //     return axios.get('/question/api/task_classification_excel', {
    //         responseType: 'blob',
    //         params: params,
    //     })
    //         .then((response) => {
    //             const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
    //             const link = document.createElement('a');
    //             link.href = downloadUrl;
    //             link.setAttribute('download', `題目分類匯出.xlsx`);
    //             document.body.appendChild(link);
    //             link.click();
    //             link.remove();
    //         });
    // }
    // const postTaskClassificationExcelData = (data) => {
    //     onBefore({
    //         axiosMode: "post"
    //     })
    //     axios.post('/question/api/task_classification_excel',
    //         data
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status !== "success") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "post",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "post",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "post",
    //                     status: "error"
    //                 }
    //             )
    //         })

    // }
    // const patchTaskClassificationExcelData = (data) => {
    //     onBefore({
    //         axiosMode: "patch"
    //     })
    //     axios.patch('/question/api/task_classification_excel',
    //         data

    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status !== "success") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "patch",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "patch",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "patch",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    // const deleteTaskClassificationExcelData = (data) => {
    //     onBefore({
    //         axiosMode: "delete"
    //     })
    //     axios.delete('/question/api/task_classification_excel',
    //         {
    //             data
    //         }
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status !== "success") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "delete",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    return {
        // TaskClassificationExcelData: data,
        getDepartmentRoleManagementExcelData,
        getDepartmentRoleManagementExcelDataSample,
        importDepartmentRoleManagementExcelData,
        // postTaskClassificationExcelData,
        // patchTaskClassificationExcelData,
        // deleteTaskClassificationExcelData,
    }
}
export { useDepartmentRoleManagementExcel }
